<!-- TODO: move to own component -->
<ui-modal
  [isOpened]="isModalOpened"
  modalTitle="Solver"
  (isOpenedChange)="modalChanged($event)"
>
  <div class="modal-body">
    <form
      [formGroup]="solverForm"
      (ngSubmit)="onSolverSubmit()"
      autocomplete="off"
    >
      <div class="solver-row">
        <div class="clr-form-control">
          <label class="clr-control-label">For</label>
          <div class="selector-container-for small-top-padding">
            <app-selector
              class="selector"
              [formControlName]="'targetField'"
              [passedItems]="legComponent.leg.solver.targetFields"
              [isSearch]="false"
            ></app-selector>
          </div>
        </div>
        <span class="equal small-top-padding">=</span>
        <!-- <clr-input-container> -->
        <input
          class="clr-input small-top-padding"
          id="targetPrice"
          [formControlName]="'targetPrice'"
          [inputValidator]="['numericShorthand']"
          type="string"
        />
        <!-- </clr-input-container> -->
        <div class="clr-form-control">
          <div class="selector-container-cur small-top-padding">
            <app-selector
              class="selector"
              [formControlName]="'cross'"
              [passedItems]="crossValues"
              required
            ></app-selector>
          </div>
        </div>
      </div>
      <div class="solver-row">
        <div class="clr-form-control">
          <label class="clr-control-label">By Changing</label>
          <div class="selector-container-for small-top-padding">
            <app-selector
              class="selector"
              [formControlName]="'inputField'"
              [passedItems]="legComponent.leg.solver.inputFields"
              required
            ></app-selector>
          </div>
        </div>
        <div class="clr-form-control">
          <div class="solved-timeTaken-container">
            <label class="clr-control-label solved-label">Solved </label>
            <span class="timeTaken">
              {{ timeTaken !== null ? 'in' : null }}
              {{ timeTaken | number: '1.0-0' }}
              {{ timeTaken !== null ? 'ms' : '' }}
            </span>
          </div>
          <input
            class="clr-input small-top-padding"
            [formControlName]="'solvedValue'"
          />
        </div>
      </div>
      <hr class="hard-return" />
      <div class="modal-footer">
        <button type="button" class="ui-button" (click)="cancel()">
          Cancel
        </button>
        <button
          type="submit"
          class="ui-button primary modal-footer__button"
          [disabled]="!solverForm.valid || currentlySolving"
        >
          <div
            class="modal-footer__button__spinner-container"
            *ngIf="currentlySolving; else allowPricing"
          >
            <span class="spinner spinner-sm spinner-inverse"> </span>
          </div>

          <ng-template #allowPricing> Solve </ng-template>
        </button>
        <button
          type="button"
          class="ui-button primary"
          (click)="applySolvedValue()"
        >
          Apply
        </button>
      </div>
    </form>
  </div>
</ui-modal>
